/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2BackIcon16Regular = forwardRef('MediaUiASkip2BackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3.5a.75.75 0 0 1 1.5 0v3.099l5.401-3.601A1.35 1.35 0 0 1 9 4.12v2.144l4.901-3.267A1.35 1.35 0 0 1 16 4.12v7.758a1.35 1.35 0 0 1-2.099 1.123L9 9.735v2.144a1.35 1.35 0 0 1-2.099 1.123L1.5 9.402V12.5a.75.75 0 0 1-1.5 0v-9Zm7.5 8.099L2.102 8 7.5 4.401V11.6Zm7 0L9.102 8 14.5 4.401V11.6Z" })));
});
